import React from 'react';
import "./css/Loading.css";


const Loading = ()=>{
    return(

<div className="load-wrapp">
    <div className="load-3">
      <div className="line"></div>
      <div className="line"></div>
      <div className="line"></div>
    </div>
  </div>
    );

}
export default Loading;